import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import axios from "../../services/api/HttpService";

const RedirectFromMIIAWinner = () => {
  const { param } = useParams();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchRetireeId = async () => {
      try {
        const response = await axios.get(`${API_URL}api/locations/${param}`);
        const retireeId = response?.data?.data?.retireeId;

        if (retireeId) {
          localStorage.setItem('selectedRetireeId', retireeId);
        } else {
          console.warn("No retireeId found in location data");
        }
      } catch (error) {
        console.error("Error fetching location data:", error);
      } finally {
        setLoading(false);
        setShouldRedirect(true);
      }
    };

    if (param) {
      fetchRetireeId();
    } else {
      setShouldRedirect(true);
      setLoading(false);
    }
  }, [param, API_URL]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (shouldRedirect) {
    return <Navigate to="/retirees" replace />;
  }

  return null;
};

export default RedirectFromMIIAWinner;
